import React from 'react';
import LegalPageLayout, { LegalSub, LegalContact } from '../components/legal/LegalPageLayout';

const PrivacyPolicyPage = () => {
  const sections = [
    {
      id: 'introduction',
      title: 'Introduction',
      body: (
        <>
          <p>Fortschritt Medical Supplies Inc. ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or engage with our services, in accordance with the Data Privacy Act of 2012 (Republic Act No. 10173) of the Philippines and its Implementing Rules and Regulations.</p>
          <p>By accessing or using our website, you consent to the collection and use of information in accordance with this policy. If you do not agree with our policies and practices, please do not use our services.</p>
        </>
      ),
    },
    {
      id: 'information-we-collect',
      title: 'Information We Collect',
      body: (
        <>
          <LegalSub>2.1 Personal Information</LegalSub>
          <p>We may collect personal information that you voluntarily provide when you:</p>
          <ul className="premium-list space-y-2.5">
            <li>Submit inquiries through our contact forms</li>
            <li>Request product information, quotes, or brochures</li>
            <li>Register for events or educational programs</li>
            <li>Subscribe to newsletters or marketing communications</li>
          </ul>
          <p>This information may include: name, email address, phone number, professional credentials, hospital/clinic affiliation, mailing address, and specialty area.</p>
          <LegalSub>2.2 Automatically Collected Information</LegalSub>
          <p>When you visit our website, we may automatically collect:</p>
          <ul className="premium-list space-y-2.5">
            <li>IP address and device identifiers</li>
            <li>Browser type and version</li>
            <li>Pages visited and time spent on pages</li>
            <li>Referring website addresses</li>
            <li>Geographic location data (country/region level)</li>
          </ul>
        </>
      ),
    },
    {
      id: 'how-we-use',
      title: 'How We Use Your Information',
      body: (
        <>
          <p>We use collected information for the following purposes:</p>
          <ul className="premium-list space-y-2.5">
            <li>To respond to your inquiries and provide customer support</li>
            <li>To process product orders and deliver requested information</li>
            <li>To send marketing communications (with your consent)</li>
            <li>To improve our website, products, and services</li>
            <li>To comply with legal obligations and regulatory requirements</li>
            <li>To prevent fraud and enhance security</li>
            <li>To conduct market research and analysis</li>
          </ul>
        </>
      ),
    },
    {
      id: 'data-sharing',
      title: 'Data Sharing and Disclosure',
      body: (
        <>
          <p>We do not sell your personal information. We may share your information with:</p>
          <ul className="premium-list space-y-2.5">
            <li><strong>Service Providers:</strong> Third-party vendors who assist with website hosting, email delivery, and analytics</li>
            <li><strong>Business Partners:</strong> Medical Inventi (manufacturer) for product support and technical inquiries</li>
            <li><strong>Legal Authorities:</strong> When required by Philippine law or to protect our legal rights</li>
            <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets</li>
          </ul>
        </>
      ),
    },
    {
      id: 'data-security',
      title: 'Data Security',
      body: (
        <p>We implement appropriate technical and organizational security measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure.</p>
      ),
    },
    {
      id: 'your-rights',
      title: 'Your Rights Under the Data Privacy Act',
      body: (
        <>
          <p>Under the Data Privacy Act of 2012, you have the right to:</p>
          <ul className="premium-list space-y-2.5">
            <li>Access your personal data we hold</li>
            <li>Correct inaccurate or incomplete data</li>
            <li>Erase or block your personal data in certain circumstances</li>
            <li>Object to processing of your personal data</li>
            <li>Withdraw consent at any time</li>
            <li>Lodge a complaint with the National Privacy Commission</li>
          </ul>
          <p>To exercise these rights, please contact us at <a href="mailto:fms.medequip@gmail.com">fms.medequip@gmail.com</a></p>
        </>
      ),
    },
    {
      id: 'contact',
      title: 'Contact Information',
      body: <LegalContact intro="If you have questions about this Privacy Policy, please contact our Data Protection Officer:" />,
    },
  ];

  return (
    <LegalPageLayout
      testId="privacy-policy-page"
      title="Privacy Policy"
      subtitle="How we collect, use and safeguard your information under the Philippine Data Privacy Act of 2012."
      updated="December 2024"
      sections={sections}
    />
  );
};

export default PrivacyPolicyPage;
